import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import colors from './colors.js';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlayCircleOutlineSharpIcon from '@material-ui/icons/PlayCircleOutlineSharp';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import { withCustomAudio } from 'react-soundplayer/addons';

const useStyles = makeStyles(theme => ({
  listItem: {
    cursor: "default",
    paddingLeft: 0,
    color: colors.blue,
  },
  listItemText: {
    color: colors.blue,
  },
  listItemIcon: {
    color: colors.blue,
  },
}));

export const SoundPlayer = withCustomAudio(props => {
  const classes = useStyles();
  return (
    <>
      <ListItem className={classes.listItem} button disableRipple disableTouchRipple disableFocusRibble key={props.title}>
        <CustomPlayButton {...props} />
        <ListItemText classNam={classes.listItemText} primary={props.title} />
      </ListItem>
      <Divider light />
    </>
  );
});


class CustomPlayButton extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { playing, seeking } = this.props;

    return (
      playing !== nextProps.playing || seeking !== nextProps.seeking
    );
  }

  handleClick = (e) => {
    const { playing, soundCloudAudio, onTogglePlay } = this.props;

    if (!playing) {
      soundCloudAudio && soundCloudAudio.play({
        playlistIndex: soundCloudAudio._playlistIndex
      });
      this.props.onPlay();
    } else {
      soundCloudAudio && soundCloudAudio.pause();
      this.props.onPause();
    }

    onTogglePlay && onTogglePlay(e);
  }

  render () {
    return (
      <ListItemIcon onClick={this.handleClick}>
        { this.props.playing ? <PauseIcon /> : <PlayArrowIcon /> }
      </ListItemIcon>
    );
  }
}

const useHeroStyles = makeStyles(theme => ({
  heroPlayerContainer: {
    marginTop: theme.spacing(4),
    cursor: "default",
    paddingLeft: 0,
    color: colors.darkBlue,
    alignItems: "center",
    display: "flex",
  },
  heroPauseIcon: {
    fill: colors.darkBlue,
    height: theme.spacing(5),
    width: theme.spacing(5),
    "&:active": {
      fill: colors.blue
    },
    "&:hover": {
      fill: colors.darkerBlue
    }
  },
  heroPlayIcon: {
    fill: colors.darkBlue,
    height: theme.spacing(5),
    width: theme.spacing(5),
    "&:active": {
      fill: colors.blue
    },
    "&:hover": {
      fill: colors.darkerBlue
    }
  },
  buttonContainer: {
    cursor: "pointer",
    marginRight: theme.spacing(2),
    height: theme.spacing(5),
    width: theme.spacing(5),
  }
}));

export const HeroSoundPlayer = withCustomAudio(props => {
  const classes = useHeroStyles();
  return (
    <div className={classes.heroPlayerContainer} >
      <HeroCustomPlayButton {...{...props, classes}} />
      <Typography align="left" variant="h6">
        {props.title}
      </Typography>
    </div>
  );
});


class HeroCustomPlayButton extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { playing, seeking } = this.props;

    return (
      playing !== nextProps.playing || seeking !== nextProps.seeking
    );
  }

  handleClick = (e) => {
    const { playing, soundCloudAudio, onTogglePlay } = this.props;

    if (!playing) {
      soundCloudAudio && soundCloudAudio.play({
        playlistIndex: soundCloudAudio._playlistIndex
      });
      this.props.onPlay();
    } else {
      soundCloudAudio && soundCloudAudio.pause();
      this.props.onPause();
    }

    onTogglePlay && onTogglePlay(e);
  }

  render () {
    return (
      <div className={this.props.classes.buttonContainer} onClick={this.handleClick}>
          { this.props.playing ?
            <PauseCircleOutlineIcon className={this.props.classes.heroPauseIcon} />
          :
            <PlayCircleOutlineSharpIcon className={this.props.classes.heroPlayIcon}/>
          }
      </div>
    );
  }
}
